"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _Address = _interopRequireDefault(require("../Address/Address"));

var _Date = _interopRequireDefault(require("../../fields/Date/Date"));

var _PhoneNumber = _interopRequireDefault(require("../PhoneNumber/PhoneNumber"));

var _Select = _interopRequireDefault(require("../../fields/Select/Select"));

var _Textfield = _interopRequireDefault(require("../../fields/Textfield/Textfield"));

var _personalDetailsConfig = require("./personalDetailsConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var PersonalDetailsDefinition = _flowRuntime["default"].tdz(function () {
  return _personalDetailsConfig.PersonalDetailsDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("personalDetails", _flowRuntime["default"].ref(PersonalDetailsDefinition))));

var PersonalDetailsFields = function PersonalDetailsFields(_arg) {
  var componentKey = _arg.componentKey,
      personalDetails = _arg.personalDetails;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-wrapper"
  }, personalDetails.options.title && /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    key: _personalDetailsConfig.title.key,
    select: _personalDetailsConfig.title,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
    key: _personalDetailsConfig.firstName.key,
    textfield: _personalDetailsConfig.firstName,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  }), personalDetails.options.middleName && /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
    key: _personalDetailsConfig.middleName.key,
    textfield: _personalDetailsConfig.middleName,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  }), /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
    key: _personalDetailsConfig.lastName.key,
    textfield: _personalDetailsConfig.lastName,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  })), personalDetails.options.email && /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
    key: _personalDetailsConfig.email.key,
    textfield: _personalDetailsConfig.email,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  }), personalDetails.options.alternativeEmail && /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
    key: _personalDetailsConfig.alternativeEmail.key,
    textfield: _personalDetailsConfig.alternativeEmail,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  }), personalDetails.options.dateOfBirth && /*#__PURE__*/_react["default"].createElement(_Date["default"], {
    key: _personalDetailsConfig.dateOfBirth.key,
    date: _personalDetailsConfig.dateOfBirth,
    parentKey: componentKey,
    inheritedFieldValidation: personalDetails.inheritedFieldValidation
  }), personalDetails.options.phoneNumber.displayed && /*#__PURE__*/_react["default"].createElement(_PhoneNumber["default"], {
    display: personalDetails.options.phoneNumber,
    parentKey: componentKey // $FlowExpectedError
    ,
    phoneNumber: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _personalDetailsConfig.phoneNumber), {}, {
      key: _personalDetailsConfig.phoneNumber.key,
      options: personalDetails.options.phoneNumber,
      inheritedFieldValidation: personalDetails.inheritedFieldValidation,
      inheritedComponentValidation: personalDetails.inheritedComponentValidation
    })
  }), personalDetails.options.address.displayed && /*#__PURE__*/_react["default"].createElement(_Address["default"], {
    address: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _personalDetailsConfig.address), {}, {
      key: _personalDetailsConfig.address.key,
      options: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _personalDetailsConfig.address.options), personalDetails.options.address),
      inheritedFieldValidation: personalDetails.inheritedFieldValidation
    }),
    parentKey: componentKey
  }));
};

var _default = PersonalDetailsFields;
exports["default"] = _default;